// extracted by mini-css-extract-plugin
export var interview_card = "InterviewCard-module--interview_card--oA5RD";
export var interview_card_link = "InterviewCard-module--interview_card_link--tq8B0";
export var interview_card_date = "InterviewCard-module--interview_card_date--IXXnc";
export var interview_card_thumbnail = "InterviewCard-module--interview_card_thumbnail--6ovE4";
export var interview_card_thumbnail_img = "InterviewCard-module--interview_card_thumbnail_img--8v4uP";
export var interview_card_header = "InterviewCard-module--interview_card_header--ofiVd";
export var interview_card_title = "InterviewCard-module--interview_card_title--MBG7r";